/**
 * Include any module and built-in Sphere apps here, then register them with the framework.
 */
import { SpherePlatformApps } from '@sphere/platform';
import {
    AdministrationApp,
    CalendarManagerApp,
    CriticalListsApp,
    CurveBuilderApp,
    DataInsightsApp,
    DataManagementApp,
    DataSupportApp,
    InternalToolsApp,
    // KplerApp // Hidden for now
    MarketViewApp,
    WorkflowApp
} from 'built-in-apps';
import { NAPowerMarketsApp } from 'na-power-markets';
import { InstantAnalystApp } from 'instant-analyst';
import { SymbolSearchApp } from 'symbol-search';

/**
 * Register platform apps here. They should be defined and implemented in a separate library module.
 */
export const spherePlatformApps = new SpherePlatformApps([
    MarketViewApp,
    DataManagementApp,
    DataSupportApp,
    DataInsightsApp,
    CriticalListsApp,
    CurveBuilderApp,
    WorkflowApp,
    CalendarManagerApp,
    AdministrationApp,
    // KplerApp // Hidden for now DGP-13014
    NAPowerMarketsApp,
    InternalToolsApp,
    InstantAnalystApp,
    SymbolSearchApp
]);
